import { weeklyItems } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function WeeklyRoundup() {
  return (
    <section id="weekly" className="scroll-mt-20 bg-accent-600 py-14 md:py-20">
      <div className="chigua-container mx-auto">
        <div className="flex flex-col gap-3 text-background-50 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-background-200">
              <span className="h-px w-6 bg-current"></span>
              Weekly Roundup
            </p>
            <h2 className="mt-2 font-display text-2xl leading-snug sm:text-3xl">每周盘点 · 错过也不慌</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100">
              编辑部每周日为错过的吃瓜人做一张「补课表」，用最短的时间，把一周最值得回看的瓜从头到尾捋顺。
            </p>
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-2 text-xs text-background-50 backdrop-blur">
            <i className="ri-calendar-check-fill"></i> 本周已更新 4 期
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {weeklyItems.map((w, i) => (
            <article
              key={w.id}
              className="group overflow-hidden rounded-[24px] bg-background-50 text-foreground-900 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/2] w-full overflow-hidden">
                <img
                  src={w.cover}
                  alt={w.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-bold text-background-50">
                  {w.tag}
                </span>
                {i === 0 && (
                  <span className="absolute right-3 top-3 grid h-8 w-8 place-items-center rounded-full bg-secondary-500 text-sm font-bold text-background-50">
                    <i className="ri-star-fill"></i>
                  </span>
                )}
              </div>
              <div className="p-4 md:p-5">
                <h3 className="line-clamp-2 min-h-[2.6rem] text-[15px] font-bold leading-snug text-foreground-900 transition-colors group-hover:text-primary-700">
                  {w.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{w.abstract}</p>
                <div className="mt-3 flex items-center justify-between text-xs text-foreground-400">
                  <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{w.views}</span>
                  <span className="inline-flex items-center gap-1 font-semibold text-accent-700">
                    补课去 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}